(function () {
  'use strict';
  if (!window.customElements || window.customElements.get('lbp-catalog')) return;
  const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
  class LBPCatalog extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected) this.mount(); });
    }
    disconnectedCallback() { this.controller?.abort(); }
    mount() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.grid = this.querySelector('[data-grid]');
      if (!this.grid) return;
      this.cards = Array.from(this.grid.querySelectorAll('[data-card]'));
      this.search = this.querySelector('[data-search]');
      this.sort = this.querySelector('[data-sort]');
      this.series = this.querySelector('[data-series]');
      this.sizes = this.querySelector('[data-size]');
      this.category = '';
      this.search.value = '';
      this.sort.value = 'manual';
      this.records = this.cards.map((card, index) => ({card,index,title:card.dataset.title || '',category:(card.dataset.category || '').trim(),series:(card.dataset.series || '').trim(),sizes:(card.dataset.sizes || '').split(',').map(s => s.trim()).filter(Boolean),search:normalize(card.dataset.searchText)}));
      const categories = this.querySelector('[data-categories]');
      categories.querySelectorAll('[data-generated]').forEach(el => el.remove());
      for (const category of new Set(this.records.map(r => r.category).filter(Boolean))) {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.category = category; button.dataset.generated = '';
        button.setAttribute('aria-pressed', 'false'); button.textContent = category;
        categories.appendChild(button);
      }
      this.populate(this.series, this.records.map(r => r.series), this.querySelector('[data-series-wrap]'));
      this.populate(this.sizes, this.records.flatMap(r => r.sizes), this.querySelector('[data-size-wrap]'));
      categories.addEventListener('click', event => {
        const button = event.target.closest('[data-category]');
        if (!button || !categories.contains(button)) return;
        this.category = button.dataset.category; this.update();
      }, options);
      for (const input of [this.search,this.sort,this.series,this.sizes]) input.addEventListener(input === this.search ? 'input' : 'change', () => this.update(), options);
      this.querySelector('[data-reset]').addEventListener('click', () => { this.reset(); this.search.focus(); }, options);
      document.addEventListener('shopify:block:select', event => {
        if (this.contains(event.target)) this.reset();
      }, options);
      this.querySelector('[data-controls]').hidden = false;
      this.update();
    }
    populate(select, values, wrapper) {
      Array.from(select.options).slice(1).forEach(option => option.remove());
      const unique = Array.from(new Set(values.filter(Boolean)));
      for (const value of unique) { const option = document.createElement('option'); option.value = value; option.textContent = value; select.appendChild(option); }
      select.value = ''; wrapper.hidden = unique.length === 0;
    }
    reset() { this.category=''; this.search.value=''; this.sort.value='manual'; this.series.value=''; this.sizes.value=''; this.update(); }
    update() {
      const query = normalize(this.search.value);
      let visible = 0;
      const ordered = [...this.records].sort((a,b) => {
        if (this.sort.value === 'manual') return a.index-b.index;
        const result = a.title.localeCompare(b.title, undefined, {numeric:true,sensitivity:'base'});
        return (this.sort.value === 'title-descending' ? -result : result) || a.index-b.index;
      });
      for (const item of ordered) {
        const match = (!this.category || item.category === this.category) && (!query || item.search.includes(query)) && (!this.series.value || item.series === this.series.value) && (!this.sizes.value || item.sizes.includes(this.sizes.value));
        item.card.hidden = !match;
        if (match) visible++;
        this.grid.appendChild(item.card);
      }
      this.querySelectorAll('button[data-category]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === this.category)));
      this.querySelector('[data-count]').textContent = visible+' '+(this.dataset.resultsLabel || 'items shown');
      this.querySelector('[data-empty]').hidden = visible !== 0;
    }
  }
  window.customElements.define('lbp-catalog', LBPCatalog);
})();
